import React from "react";
import { Link, useLocation } from "react-router-dom";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import Collapse from "@mui/material/Collapse";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

export default function NavItem({
  label,
  icon,
  level1Labels,
  level1Icons,
  level1Links,
}) {
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  const location = useLocation();

  return (
    <List disablePadding>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={label} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          disablePadding
          sx={{
            backgroundColor: "grey",
            textDecoration: "none",
          }}
        >
          {level1Labels.map((item, i) => (
            <Link
              to={level1Links[i]}
              key={i}
              style={{ textDecoration: "none" }}
            >
              <ListItemButton
                sx={{
                  paddingLeft: "30px",
                  backgroundColor:
                    location.pathname === level1Links[i]
                      ? "#9c27b0"
                      : "#404040",
                  "&:hover": {
                    backgroundColor:
                      location.pathname === level1Links[i]
                        ? "#9c27b0"
                        : "#404040",
                    opacity: location.pathname === level1Links[i] ? 1 : 0.8,
                    transition: "all 0.1s ease-in-out",
                  },
                  ...(location.pathname === level1Links[i] && {
                    "&:hover": {
                      backgroundColor: "#9c27b0",
                      opacity: 1,
                    },
                  }),
                }}
              >
                <ListItemIcon>{level1Icons[i]}</ListItemIcon>
                <ListItemText
                  primary={item}
                  sx={{
                    fontSize: 14,
                    lineHeight: "24px",
                    letterSpacing: "0.02em",
                    color: "#f0f0f0",
                  }}
                />
              </ListItemButton>
            </Link>
          ))}
        </List>
      </Collapse>
    </List>
  );
}
